module.exports = require("@u-wave/react-vimeo");